import { createContext } from "react";

export const BudgetContext = createContext(null)
export const StyleContext = createContext(null)